import {
  CustomTemplateListRequest,
  CustomTemplateListResponse,
  GetItemsResponse,
  ReadCustomTemplateListResponse
} from "../../../ui/gzCustomTemplateList/types";
import {ConsoleRequest, DataProviderType} from "../../../utils/request";
import {BaseWebComponentDataProvider} from "../../../framework/BaseWebComponentDataProvider";
import {IntegrationInstancesMethods} from "../types";
import {computeRequestForReadIntegrations, populateData, isButtonDisabled} from "../../common/utils";
import {CARD_TYPES, GRID_TYPES, LICENSE_STATUSES_AVAILABLE} from "../../common/constants";
import {IntegrationsMarketplaceCardActionButton} from "../../gzIntegrationsMarketplaceCard/types";
import {ButtonColors, ButtonTypes} from "../../../ui/gzButton/types";
import {translateFn} from "../../../utils/translator.helper";
import { Dependencies } from "../../integrationsMarketplaceAppContainer/types/dependencies";


export class IntegrationsMarketplaceGridAvailableNirvanaDataProvider extends BaseWebComponentDataProvider {
  private cache: CustomTemplateListResponse | null;
  private endpoint = 'IntegrationTemplates';

  constructor(public dependencies: Dependencies) {
    super();
  }

  async getItems(request: CustomTemplateListRequest): Promise<GetItemsResponse> {
    const newRequest = computeRequestForReadIntegrations(request);
    const response = await this.readRecords(newRequest);

    const data = this.computeItemsData(response);

    return {
      itemsTotal: response.total,
      items: data,
    };
  }

  private computeItemsData(response: ReadCustomTemplateListResponse): any {
    const data = populateData(response.data, GRID_TYPES.AVAILABLE, this.dependencies.permissions);

    // add action buttons
    data.forEach((item: any) => {
      item.actionButtons = this.getActionButtons(item);
    });

    return data;
  }

  private getActionButtons(item: any): IntegrationsMarketplaceCardActionButton[] {
    if (item.cardType === CARD_TYPES.DEEP_LINK) {
      return [
        {
          label: translateFn('Go to Configuration'),
          type: ButtonTypes.OUTLINE,
          color: ButtonColors.SECONDARY,
        },
      ];
    } else if (item.cardType === CARD_TYPES.CONFIGURABLE) {
      return [
        {
          label: translateFn('Configure'),
          type: ButtonTypes.OUTLINE,
          color: ButtonColors.SECONDARY,
          disabled: isButtonDisabled(this.dependencies.permissions, item),
        },
      ];
    }

    return [];
  }

  private async readRecords(request): Promise<ReadCustomTemplateListResponse> {
    const payload = ConsoleRequest.mapGridRequestToPayload(request, this.dependencies.getTimezone());
    payload.extraParams = request.extraParams || {};

    return await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.ENDPOINTS,
      payload,
      endpoint: this.endpoint,
      method: IntegrationInstancesMethods.READ_RECORDS,
    });
  }

}
